import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom"; // For navigation
import LanguageSelector from "../common/LanguageSelector";
import UserProfileForMSIL from "./UserProfileForMSIL";
import '../styles/SubHeader.css';

const SubHeaderForMSIL = () => {
  const { t } = useTranslation();
  const navigate = useNavigate(); // React Router's hook for navigation

  return (
    <div className="container-fluid p-3 bg-white">
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center"></div>
        <div className="d-flex align-items-center gap-2">
          <LanguageSelector />
          <UserProfileForMSIL />
        </div>
      </div>
    </div>
  );
};

export default SubHeaderForMSIL;
